import apiRequest from "../../apiCall";

//  GET request
const callHomeApi = () => {
  return new Promise((resolve, reject) => {
    apiRequest("GET", "home", null, true, true)
      .then((res) => {
        sessionStorage.setItem("homeApi", JSON.stringify(res));
        resolve(res);
      })
      .catch((error) => {
        console.error("Error calling home API:", error);
        reject(error);
      });
  });
};

// POST request for advertise data
const callHomeAdvertise = (formData) => {
  return new Promise((resolve, reject) => {
    apiRequest("POST", "home/advertise", formData, true, true)
      .then((res) => {
        sessionStorage.setItem("AdvertiseApi", res);
        resolve(res);
      })

      .catch((error) => {
        console.log("Error sending Advertise Data", error);
        reject(error);
      });
  });
};

// POST request for section 2
const callSection2 = (formData) => {
  return new Promise((resolve, reject) => {
    apiRequest("POST", "home/section2", formData, true, true)
      .then((res) => {
        sessionStorage.setItem("Section2Api", res);
        resolve(res);
      })
      .catch((error) => {
        console.log("Error sending the data", error);
        reject(error);
      });
  });
};

// POST request for how to use zerozero section
const callHowToUseZeroZero = (formData) => {
  return new Promise((resolve, reject) => {
    apiRequest("POST", "home/howtousezerozero", formData, true, true)
      .then((res) => {
        sessionStorage.setItem("HowToUseZerozeroApi", JSON.stringify(res));
        resolve(res);
      })
      .catch((error) => {
        console.log("Error sending the data", error);
        reject(error);
      });
  });
};

// POST request for digital ads
const callDigitalAds = (formData) => {
  return new Promise((resolve, reject) => {
    apiRequest("POST", "home/digitalads", formData, true, true)
      .then((res) => {
        sessionStorage.setItem("digitalAds", JSON.stringify(res));
        resolve(res);
      })

      .catch((error) => {
        console.log("Error sending DigitalAds  Data", error);
        reject(error);
      });
  });
};

// api call for influencer collabs section
const callInfluencer = (formData) => {
  return new Promise((resolve, reject) => {
    apiRequest("POST", "home/influencer", formData, true, true)
      .then((res) => {
        console.log("resresresres", res);
        sessionStorage.setItem("influencerApi", JSON.stringify(res));
        resolve(res);
      })

      .catch((error) => {
        console.log("Error sending Influencer Data", error);
        reject(error);
      });
  });
};

// api call for testimonial section
const callTestimonial = (formData) => {
  return new Promise((resolve, reject) => {
    apiRequest("POST", "home/testimonial", formData, true, true)
      .then((res) => {
        sessionStorage.setItem("testimonialApi", JSON.stringify(res));
        resolve(res);
      })
      .catch((error) => {
        console.log("Error sending testimonial data", error);
        reject(error);
      });
  });
};

export default callHomeApi;
export {
  callHomeAdvertise,
  callDigitalAds,
  callInfluencer,
  callSection2,
  callHowToUseZeroZero,
  callTestimonial,
};
